export const articles = [
  {
    id: 1,
    slug: 'premier-league-fixtures-2025.html',
    title: 'Premier League Fixtures 2025: Complete Schedule & Key Matches',
    category: 'Schedule',
    date: '2025-01-26',
    excerpt: 'Complete guide to Premier League 2025 fixtures including all key matches, derby dates, and title race schedule.',
    image: 'https://public.readdy.ai/ai/img_res/0fadbf10fc7ed11d75d45d9b6b42fcdb.jpg',
    tags: ['Premier League', 'Fixtures', 'Schedule', '2025']
  },
  {
    id: 2,
    slug: 'thai-league-schedule-2025.html',
    title: 'Thai League Schedule 2025: Full Fixture List & Match Dates',
    category: 'Schedule',
    date: '2025-01-25',
    excerpt: 'Complete Thai League 2025 schedule with all fixtures, match dates, and venue information for the upcoming season.',
    image: 'https://readdy.ai/api/search-image?query=thai%20football%20league%20stadium%20packed%20with%20fans%20colorful%20atmosphere%20tropical%20setting%20evening%20match%20under%20lights%20professional%20sports%20photography%20vibrant%20energy&width=800&height=450&seq=thl2025sch&orientation=landscape',
    tags: ['Thai League', 'Schedule', 'Fixtures', 'Thailand']
  },
  {
    id: 3,
    slug: 'uefa-champions-league-fixtures.html',
    title: 'UEFA Champions League Fixtures: Knockout Stage Schedule',
    category: 'Schedule',
    date: '2025-01-24',
    excerpt: 'UEFA Champions League knockout stage fixtures with dates, times, and venue details for all matches.',
    image: 'https://readdy.ai/api/search-image?query=champions%20league%20football%20match%20iconic%20stadium%20night%20game%20under%20floodlights%20european%20football%20atmosphere%20dramatic%20lighting%20professional%20sports%20venue&width=800&height=450&seq=uclfix25&orientation=landscape',
    tags: ['Champions League', 'UEFA', 'Fixtures', 'Europe']
  },
  {
    id: 4,
    slug: 'liverpool-vs-man-city-analysis.html',
    title: 'Liverpool vs Man City Analysis: Tactical Breakdown & Predictions',
    category: 'Schedule',
    date: '2025-01-23',
    excerpt: 'In-depth tactical analysis of the Liverpool vs Manchester City clash with predictions and key player matchups.',
    image: 'https://readdy.ai/api/search-image?query=liverpool%20manchester%20city%20football%20match%20premier%20league%20stadium%20packed%20crowd%20intense%20rivalry%20atmosphere%20professional%20sports%20photography%20dynamic%20action&width=800&height=450&seq=livmci25&orientation=landscape',
    tags: ['Liverpool', 'Man City', 'Analysis', 'Premier League']
  },
  {
    id: 5,
    slug: 'thailand-national-team-schedule.html',
    title: 'Thailand National Team Schedule: Upcoming International Fixtures',
    category: 'Schedule',
    date: '2025-01-22',
    excerpt: 'Complete schedule for Thailand national football team including World Cup qualifiers and friendly matches.',
    image: 'https://readdy.ai/api/search-image?query=thailand%20national%20football%20team%20players%20in%20action%20international%20match%20stadium%20setting%20patriotic%20atmosphere%20professional%20sports%20photography%20dynamic%20movement&width=800&height=450&seq=thaint25&orientation=landscape',
    tags: ['Thailand', 'National Team', 'Schedule', 'International']
  },
  {
    id: 6,
    slug: 'premier-league-results-last-night.html',
    title: 'Premier League Results Last Night: Match Reports & Highlights',
    category: 'Results',
    date: '2025-01-26',
    excerpt: 'Complete Premier League results from last night with match reports, goals, and key moments from all fixtures.',
    image: 'https://readdy.ai/api/search-image?query=premier%20league%20football%20goal%20celebration%20players%20celebrating%20stadium%20crowd%20cheering%20night%20match%20professional%20sports%20photography%20emotional%20moment&width=800&height=450&seq=plres26&orientation=landscape',
    tags: ['Premier League', 'Results', 'Match Reports', 'Highlights']
  },
  {
    id: 7,
    slug: 'thai-league-summary.html',
    title: 'Thai League Summary: Latest Results & League Table Updates',
    category: 'Results',
    date: '2025-01-25',
    excerpt: 'Comprehensive Thai League summary with latest results, standings, and top scorers from recent matches.',
    image: 'https://readdy.ai/api/search-image?query=thai%20league%20football%20action%20shot%20players%20competing%20for%20ball%20tropical%20stadium%20setting%20intense%20match%20moment%20professional%20sports%20photography&width=800&height=450&seq=thlsum25&orientation=landscape',
    tags: ['Thai League', 'Results', 'Summary', 'Standings']
  },
  {
    id: 8,
    slug: 'man-utd-3-1-chelsea-highlights.html',
    title: 'Man Utd 3-1 Chelsea Highlights: Match Report & Analysis',
    category: 'Results',
    date: '2025-01-24',
    excerpt: 'Manchester United defeats Chelsea 3-1 with comprehensive match highlights, goals, and tactical analysis.',
    image: 'https://readdy.ai/api/search-image?query=manchester%20united%20chelsea%20football%20match%20old%20trafford%20stadium%20premier%20league%20action%20players%20in%20red%20and%20blue%20professional%20sports%20photography&width=800&height=450&seq=munche24&orientation=landscape',
    tags: ['Man Utd', 'Chelsea', 'Results', 'Premier League']
  },
  {
    id: 9,
    slug: 'thailand-1-1-vietnam.html',
    title: 'Thailand 1-1 Vietnam: Match Report & Key Moments',
    category: 'Results',
    date: '2025-01-23',
    excerpt: 'Thailand draws 1-1 with Vietnam in thrilling encounter with match report and analysis of key moments.',
    image: 'https://readdy.ai/api/search-image?query=thailand%20vietnam%20football%20match%20international%20game%20asian%20football%20stadium%20competitive%20action%20professional%20sports%20photography%20intense%20rivalry&width=800&height=450&seq=thavie23&orientation=landscape',
    tags: ['Thailand', 'Vietnam', 'Results', 'International']
  },
  {
    id: 10,
    slug: 'uefa-round-of-16-results.html',
    title: 'UEFA Round of 16 Results: Champions League Knockout Summary',
    category: 'Results',
    date: '2025-01-22',
    excerpt: 'Complete UEFA Champions League Round of 16 results with match summaries and quarter-final qualifiers.',
    image: 'https://readdy.ai/api/search-image?query=champions%20league%20knockout%20stage%20football%20match%20european%20stadium%20dramatic%20night%20atmosphere%20intense%20competition%20professional%20sports%20photography&width=800&height=450&seq=uclr1622&orientation=landscape',
    tags: ['Champions League', 'UEFA', 'Results', 'Knockout']
  },
  {
    id: 11,
    slug: 'messi-transfer-rumors.html',
    title: 'Messi Transfer Rumors: Latest Updates & Potential Destinations',
    category: 'Transfer',
    date: '2025-01-26',
    excerpt: 'Latest Lionel Messi transfer rumors with potential destinations and contract negotiations updates.',
    image: 'https://readdy.ai/api/search-image?query=lionel%20messi%20football%20player%20portrait%20professional%20athlete%20stadium%20background%20transfer%20news%20concept%20modern%20sports%20photography%20dramatic%20lighting&width=800&height=450&seq=messit26&orientation=landscape',
    tags: ['Messi', 'Transfer', 'Rumors', 'News']
  },
  {
    id: 12,
    slug: 'man-utd-signs-gareth-bale.html',
    title: 'Man Utd Signs Gareth Bale: Transfer Details & Contract Info',
    category: 'Transfer',
    date: '2025-01-25',
    excerpt: 'Manchester United completes Gareth Bale signing with full transfer details and contract information.',
    image: 'https://readdy.ai/api/search-image?query=gareth%20bale%20manchester%20united%20football%20player%20signing%20announcement%20old%20trafford%20stadium%20professional%20sports%20photography%20official%20portrait&width=800&height=450&seq=munbale25&orientation=landscape',
    tags: ['Man Utd', 'Gareth Bale', 'Transfer', 'Signing']
  },
  {
    id: 13,
    slug: 'premier-league-transfer-market.html',
    title: 'Premier League Transfer Market: January Window Analysis',
    category: 'Transfer',
    date: '2025-01-24',
    excerpt: 'Comprehensive Premier League transfer market analysis covering all January window deals and rumors.',
    image: 'https://readdy.ai/api/search-image?query=premier%20league%20transfer%20window%20football%20players%20multiple%20clubs%20jerseys%20collage%20style%20professional%20sports%20photography%20modern%20design&width=800&height=450&seq=pltran24&orientation=landscape',
    tags: ['Premier League', 'Transfer', 'Market', 'January']
  },
  {
    id: 14,
    slug: 'thai-league-foreign-players.html',
    title: 'Thai League Foreign Players: Top International Signings 2025',
    category: 'Transfer',
    date: '2025-01-23',
    excerpt: 'Analysis of top foreign players joining Thai League clubs in 2025 with transfer details and impact.',
    image: 'https://readdy.ai/api/search-image?query=international%20football%20players%20thai%20league%20diverse%20athletes%20tropical%20stadium%20setting%20professional%20sports%20photography%20multicultural%20team&width=800&height=450&seq=thlfore23&orientation=landscape',
    tags: ['Thai League', 'Foreign Players', 'Transfer', 'International']
  },
  {
    id: 15,
    slug: '10-mega-deals.html',
    title: '10 Mega Deals: Biggest Football Transfers of the Season',
    category: 'Transfer',
    date: '2025-01-22',
    excerpt: 'Top 10 biggest football transfers of the season with fees, details, and impact analysis.',
    image: 'https://readdy.ai/api/search-image?query=football%20transfer%20mega%20deals%20expensive%20signings%20world%20class%20players%20multiple%20stars%20professional%20sports%20photography%20luxury%20concept&width=800&height=450&seq=mega1022&orientation=landscape',
    tags: ['Transfers', 'Mega Deals', 'Big Money', 'Analysis']
  },
  {
    id: 16,
    slug: 'liverpool-form-analysis.html',
    title: 'Liverpool Form Analysis: Tactical Review & Performance Stats',
    category: 'Analysis',
    date: '2025-01-26',
    excerpt: 'Detailed Liverpool form analysis with tactical review, performance statistics, and future predictions.',
    image: 'https://readdy.ai/api/search-image?query=liverpool%20football%20team%20tactical%20formation%20anfield%20stadium%20professional%20match%20analysis%20modern%20sports%20photography%20strategic%20positioning&width=800&height=450&seq=livform26&orientation=landscape',
    tags: ['Liverpool', 'Analysis', 'Form', 'Tactics']
  },
  {
    id: 17,
    slug: '5-rising-stars.html',
    title: '5 Rising Stars: Young Football Talents to Watch in 2025',
    category: 'Analysis',
    date: '2025-01-25',
    excerpt: 'Profile of 5 rising star footballers to watch in 2025 with skills analysis and potential predictions.',
    image: 'https://readdy.ai/api/search-image?query=young%20football%20talents%20rising%20stars%20next%20generation%20players%20dynamic%20action%20shots%20professional%20sports%20photography%20bright%20future%20concept&width=800&height=450&seq=stars525&orientation=landscape',
    tags: ['Rising Stars', 'Young Players', 'Analysis', 'Future']
  },
  {
    id: 18,
    slug: 'pep-guardiola-tactics.html',
    title: 'Pep Guardiola Tactics: Tactical Philosophy & System Analysis',
    category: 'Analysis',
    date: '2025-01-24',
    excerpt: 'In-depth analysis of Pep Guardiola tactical philosophy and Manchester City playing system.',
    image: 'https://readdy.ai/api/search-image?query=pep%20guardiola%20manchester%20city%20manager%20tactical%20board%20coaching%20analysis%20professional%20sports%20photography%20strategic%20thinking%20concept&width=800&height=450&seq=pepguard24&orientation=landscape',
    tags: ['Pep Guardiola', 'Tactics', 'Man City', 'Analysis']
  },
  {
    id: 19,
    slug: 'why-arsenal-stronger.html',
    title: 'Why Arsenal Stronger: Tactical Evolution & Squad Depth Analysis',
    category: 'Analysis',
    date: '2025-01-23',
    excerpt: 'Analysis of why Arsenal has become stronger this season with tactical evolution and squad improvements.',
    image: 'https://readdy.ai/api/search-image?query=arsenal%20football%20team%20emirates%20stadium%20strong%20performance%20tactical%20formation%20professional%20sports%20photography%20winning%20mentality&width=800&height=450&seq=arsstro23&orientation=landscape',
    tags: ['Arsenal', 'Analysis', 'Tactics', 'Premier League']
  },
  {
    id: 20,
    slug: 'ronaldo-vs-messi.html',
    title: 'Ronaldo vs Messi: Career Statistics & Legacy Comparison',
    category: 'Analysis',
    date: '2025-01-22',
    excerpt: 'Comprehensive comparison of Ronaldo and Messi careers with statistics, achievements, and legacy analysis.',
    image: 'https://readdy.ai/api/search-image?query=cristiano%20ronaldo%20lionel%20messi%20comparison%20two%20football%20legends%20side%20by%20side%20professional%20sports%20photography%20iconic%20players%20legacy&width=800&height=450&seq=ronmes22&orientation=landscape',
    tags: ['Ronaldo', 'Messi', 'Comparison', 'Analysis']
  },
  {
    id: 21,
    slug: 'a-complete-guide-to-veewin-card-games-online-insights.html',
    title: 'A Complete Guide to Veewin Card Games & Online Insights',
    category: 'Analysis',
    date: '2025-01-27',
    excerpt: 'Comprehensive guide to Veewin card games platform featuring popular Vietnamese and international card games.',
    image: 'https://readdy.ai/api/search-image?query=online%20card%20games%20digital%20gaming%20platform%20modern%20interface%20colorful%20cards%20poker%20chips%20professional%20gaming%20photography%20entertainment%20concept&width=800&height=450&seq=veewin27&orientation=landscape',
    tags: ['Veewin', 'Card Games', 'Online Gaming', 'Guide']
  },
  {
    id: 22,
    slug: 'debet-huong-dan-truy-cap-chinh-chu-moi-nhat-2025.html',
    title: 'Debet – hướng dẫn truy cập chính chủ mới nhất 2025',
    category: 'Analysis',
    date: '2025-01-28',
    excerpt: 'Hướng dẫn chi tiết cách truy cập Debet, các link chính chủ mới nhất và phương pháp vượt chặn hiệu quả năm 2025.',
    image: 'https://readdy.ai/api/search-image?query=online%20gaming%20platform%20secure%20access%20digital%20technology%20modern%20interface%20cybersecurity%20concept%20professional%20photography%20blue%20tones%20network%20connection&width=800&height=450&seq=debet28&orientation=landscape',
    tags: ['Debet', 'Access Guide', 'Online Platform', '2025']
  },
  {
    id: 23,
    slug: '23win-san-choi-doi-thuong-dinh-cao.html',
    title: '23win – Sân Chơi Đổi Thưởng Đỉnh Cao Dành Cho Mọi Game Thủ',
    category: 'Analysis',
    date: '2025-01-29',
    excerpt: 'Khám phá 23win - nền tảng giải trí trực tuyến với cơ chế đổi thưởng minh bạch, hàng trăm trò chơi đặc sắc và hệ thống bảo mật đa tầng tiên tiến.',
    image: 'https://readdy.ai/api/search-image?query=online%20gaming%20entertainment%20platform%20modern%20digital%20interface%20vibrant%20colors%20casino%20games%20cards%20slots%20professional%20photography%20exciting%20atmosphere%20dynamic%20layout&width=800&height=450&seq=23win29&orientation=landscape',
    tags: ['23win', 'Gaming Platform', 'Online Entertainment', 'Rewards']
  },
  {
    id: 24,
    slug: 'b52club-tan-huong-khong-gian-game-hien-dai.html',
    title: 'B52Club – Tận Hưởng Không Gian Game Hiện Đại Và Sống Động',
    category: 'Analysis',
    date: '2025-01-30',
    excerpt: 'B52Club khẳng định vị thế hàng đầu với hệ thống game đa dạng, đồ họa mượt mà và chính sách thưởng siêu hấp dẫn cho game thủ Việt.',
    image: 'https://readdy.ai/api/search-image?query=modern%20gaming%20platform%20vibrant%20digital%20interface%20card%20games%20entertainment%20colorful%20design%20professional%20photography%20exciting%20atmosphere%20dynamic%20layout&width=800&height=450&seq=b52club30&orientation=landscape',
    tags: ['B52Club', 'Gaming Platform', 'Card Games', 'Entertainment']
  },
  {
    id: 25,
    slug: 'max88-the-gioi-giai-tri-truc-tuyen-dang-lam-mua-lam-gio.html',
    title: 'Max88 – Thế Giới Giải Trí Trực Tuyến Đang Làm Mưa Làm Gió',
    category: 'Analysis',
    date: '2025-01-31',
    excerpt: 'Max88 là sân chơi trực tuyến uy tín với hàng nghìn trò chơi đa dạng, đảm bảo minh bạch, bảo mật và công bằng cho người dùng.',
    image: 'https://readdy.ai/api/search-image?query=online%20gaming%20entertainment%20platform%20modern%20interface%20vibrant%20colors%20casino%20games%20cards%20slots%20professional%20photography%20exciting%20winning%20atmosphere%20premium%20quality&width=800&height=450&seq=max8831&orientation=landscape',
    tags: ['Max88', 'Gaming Platform', 'Online Entertainment', 'Rewards']
  },
  {
    id: 26,
    slug: 'iwin-giai-tri-moi-luc-moi-noi-cung-kho-game-sieu-da-dang.html',
    title: 'Iwin – Giải Trí Mọi Lúc Mọi Nơi Cùng Kho Game Siêu Đa Dạng',
    category: 'Analysis',
    date: '2025-02-01',
    excerpt: 'Iwin là nơi hội tụ của công nghệ, sáng tạo và niềm đam mê giải trí với môi trường công bằng, minh bạch và thân thiện cho mọi người chơi.',
    image: 'https://readdy.ai/api/search-image?query=online%20gaming%20platform%20diverse%20games%20modern%20interface%20card%20games%20entertainment%20colorful%20vibrant%20design%20professional%20photography%20exciting%20atmosphere%20premium%20quality&width=800&height=450&seq=iwin01&orientation=landscape',
    tags: ['Iwin', 'Gaming Platform', 'Card Games', 'Entertainment']
  },
  {
    id: 27,
    slug: 'sunwin-cong-giai-tri-truc-tuyen-chat-luong-va-tan-tam-nhat.html',
    title: 'Sunwin – Cổng Giải Trí Trực Tuyến Chất Lượng Và Tận Tâm Nhất',
    category: 'Analysis',
    date: '2025-02-02',
    excerpt: 'Sunwin là biểu tượng của sự uy tín với giao diện chuyên nghiệp, tính năng nạp rút nhanh và hệ thống VIP đặc quyền hấp dẫn.',
    image: 'https://readdy.ai/api/search-image?query=premium%20online%20gaming%20platform%20professional%20interface%20card%20games%20slot%20machines%20vibrant%20colors%20modern%20design%20quality%20entertainment%20trusted%20platform&width=800&height=450&seq=sunwin01&orientation=landscape',
    tags: ['Sunwin', 'Gaming Platform', 'VIP Benefits', 'Card Games']
  },
  {
    id: 30,
    slug: 'X88-leading-brand-football-betting-vietnam.html',
    title: 'X88: The leading brand in football betting in Vietnam',
    category: 'Analysis',
    date: '2025-02-05',
    excerpt: 'X88 – the leading brand in football betting in Vietnam, offering a safe, transparent, and engaging betting experience with great winning opportunities for players of all levels.',
    image: 'https://readdy.ai/api/search-image?query=football%20betting%20platform%20modern%20interface%20stadium%20background%20soccer%20match%20live%20odds%20professional%20sports%20betting%20website%20vibrant%20colors%20dynamic%20atmosphere&width=800&height=450&seq=x88bet01&orientation=landscape',
    tags: ['X88', 'Football Betting', 'Vietnam', 'Sports Betting']
  },
  {
    id: 29,
    slug: 'year-end-promotion-10-free-vr-lottery-tickets-89bet.html',
    title: 'Year-end special offer: Give away 10 free VR Lottery tickets at 89BET',
    category: 'Analysis',
    date: '2025-02-04',
    excerpt: 'Discover the year-end special offer at 89BET: Give away 10 free VR Lottery tickets, enhancing the safe, transparent and attractive online betting experience.',
    image: 'https://readdy.ai/api/search-image?query=virtual%20reality%20lottery%20experience%20futuristic%20digital%20interface%20glowing%20numbers%20tickets%20vr%20headset%20concept%20modern%20technology%20professional%20photography%20vibrant%20colors%20exciting%20atmosphere&width=800&height=450&seq=89bet01&orientation=landscape',
    tags: ['89BET', 'VR Lottery', 'Free Tickets', 'Year-end Promotion']
  },
  {
    id: 28,
    slug: 'play-tp-lottery-at-n88.html',
    title: 'Play TP Lottery at N88 – Get 5% cashback for every losing ticket',
    category: 'Analysis',
    date: '2025-02-03',
    excerpt: 'Play TP Lottery at N88 and get 5% Cashback for Every Losing Ticket. Experience safety, transparency and high winning chances on this reputable platform.',
    image: 'https://readdy.ai/api/search-image?query=online%20lottery%20platform%20digital%20tickets%20winning%20numbers%20colorful%20interface%20modern%20technology%20professional%20photography%20vibrant%20colors%20exciting%20atmosphere%20jackpot%20concept&width=800&height=450&seq=n88lot01&orientation=landscape',
    tags: ['N88', 'TP Lottery', 'Cashback', 'Online Lottery']
  }
];